import React from 'react';

export const PixelShiftIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="4" fill="currentColor" fillOpacity="0.1" />
    <path
      d="M7 7H9V9H7V7Z"
      fill="currentColor"
    />
    <path
      d="M7 11H9V13H7V11Z"
      fill="currentColor"
    />
    <path
      d="M7 15H9V17H7V15Z"
      fill="currentColor"
    />
    <path
      d="M11 7H13V9H11V7Z"
      fill="currentColor"
    />
     <path
      d="M15 11H17V13H15V11Z"
      fill="currentColor"
      className="transition-transform duration-300 ease-in-out"
    />
  </svg>
);

